/**
 * WHO-6629. Statsig gate for the project workspaces (switcher, heart menu,
 * board, moodboard, proposal, invoices, client link). On top of the step 6
 * gate and the gateway's `proBuyerProjectsAccess`: off or loading means the
 * site looks exactly as it does today. Its own module (re-exported by
 * `workspaces.static`) so the provider in `_app` imports nothing else.
 */
export const PRO_WORKSPACES_GATE = "pro_buyer_project_workspaces";
